import { useEffect as f } from "react";
import { useHistory as n } from "react-router-dom";
import { b as u } from "../helpers-CNa1KUVl.mjs";
function p(s, o = () => {
}) {
  const t = n();
  f(() => {
    u(t.location.hash, s) || t.push(`#${s}`);
  }, [s, t]), f(() => t.listen((i) => {
    const r = i.hash.length > 1 ? i.hash.substr(1) : "";
    r && !u(r, s) && o(r);
  }), [s, t, o]);
}
export {
  p as default
};
